// Run `fn` once the DOM is ready — immediately if it already is.
//
// ★ A bare `document.addEventListener('DOMContentLoaded', fn)` inside a Vite/ESM module NEVER fires
// when the module is evaluated after the DOM is ready (a lazily imported chunk, a dynamic import, a
// module that moved later in the bundle) — the recurring "handler silently never runs" bug
// (deal_pricing_adjustment_fix, 2026-06). This helper is the one place that pattern is allowed;
// bin/lint-footguns blocks it everywhere else.
export function onDomReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true })
  } else {
    fn()
  }
}
